<script setup>
import {useKeenSlider} from 'keen-slider/vue'
import {useI18n} from "vue-i18n";
import StarCheck from "@i/star-check.svg?component";
import {sliderAnimations} from "@/utilities";
import {onMounted, ref} from "vue";

const [container] = useKeenSlider({
    loop: true,
    breakpoints: {
        '(min-width: 640px)': {
            slides: {perView: 2, spacing: 5},
        },
        '(min-width: 1000px)': {
            slides: {perView: 3, spacing: 10},
        },

    },
    slides: {perView: 1},
}, [
    (slider) => sliderAnimations(slider, 5000),
])
const {t} = useI18n();

const gallery = [
    t('Premium quality'),
    t('Secure payment'),
    t('First things first'),
];

const loaded = ref(false);

onMounted(() => {
    loaded.value = true;
})

</script>

<template>
    <div
        ref="container"
        :class="{'opacity-0' : !loaded}"
        class="keen-slider flex overflow-hidden transition-opacity duration-300"
    >
        <div
            v-for="(item ,i) in [...gallery, ...gallery]"
            :key="i"
            class="keen-slider__slide"
        >
            <div

                class="flex h-10 cursor-default flex-row items-center justify-center space-x-3 md:min-w-max md:space-x-4"
            >
                <StarCheck class="size-8 fill-black" />
                <div class="text-center text-sm uppercase sm:text-base">
                    {{ item }}
                </div>
            </div>
        </div>
    </div>
</template>
